import c from "../../utils/constants";
import env from "../../utils/env";

class LoginController {
  constructor(AuthService, NavigationService, AppContextService, EventsService, $state) {
    'ngInject';

    this.authService = AuthService;
    this.navigationService = NavigationService;
    this.appContextService = AppContextService;
    this.eventsService = EventsService;

    this.username = '';
    this.password = '';
    this.verificationCode = '';
    this.errorMessage = '';
    this.isLoading = false;
    this.loginText = 'Verify';
    this.phase = 1;
  }

  $onInit() {
    this.eventsService.listen(c.events.VERIFICATION_CODE_RECEIEVED, (e, args) => {
      console.log(args);
      this.verificationCode = args;
      this.submit();
    });
  }

  submit(e) {
    if (e)
      e.preventDefault();

    this.isLoading = true;
    this.loginText = 'Checking...';

    if (this.phase === 1) {
      let payload = {
        userName: this.username,
        password: this.password,
      }
      this.authService.initiateLogin(payload, this._onInitiateLoginSuccess.bind(this), this._onInitiateLoginFailure.bind(this));
    } else {
      let payload = {
        userName: this.username,
        password: this.password,
        verificationCode: this.verificationCode,
      }
      this.authService.login(payload, this._onLoginSuccess.bind(this), this._onLoginFailure.bind(this));
    }
  }

  _onInitiateLoginSuccess(response) {
    this.setErrorMessage("");

    this.isLoading = false;
    this.loginText = 'Login';

    this.phoneNumber = response.data.phoneNumber;
    this.phase = 2;

    setTimeout(() => {
      document.getElementById("verificationCode").focus();
    }, 500);
  }

  _onInitiateLoginFailure(error) {
    console.log("Initiate login failed:", error.data.message);

    this.isLoading = false;
    this.loginText = 'Verify';

    this.setErrorMessage("Invalid username or password.");
  }

  _onLoginSuccess(response) {
    this.setErrorMessage("");

    this.appContextService.fetchAppContext((response) => {
      const roles = response.data.roles;
      if(this.appContextService.hasAccess(roles)) {
        this.appContextService.setAppContext(response.data);
        let defaultState = env.defaultState();
        this.navigationService.go(defaultState);

        // Let the world know that you have access to bigfoot! yaay!!
        this.eventsService.broadcast(c.events.AUTHORIZATION_SUCCESS);
      } else {
        this.setErrorMessage("You are not authorized to access this application.");
      }
    },
    () => {
      this.setErrorMessage("You are not authorized to access this application.");
    })
  }

  _onLoginFailure(error) {
    console.log("Login failed:", error.data.message);

    this.isLoading = false;
    this.loginText = 'Login';

    this.setErrorMessage("Invalid verification code.");
  }

  setErrorMessage(error) {
    this.errorMessage = error;
    this.isLoading = false;
  }

}

export default LoginController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/containers/login/login.controller.js
 **/